"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TemplateMessageField = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ui = require("@alycecom/ui");

var TemplateMessageField = function TemplateMessageField(_ref) {
  var name = _ref.name,
      value = _ref.value,
      error = _ref.error,
      disabled = _ref.disabled,
      charsLimit = _ref.charsLimit,
      formProps = (0, _objectWithoutProperties2.default)(_ref, ["name", "value", "error", "disabled", "charsLimit"]);
  return /*#__PURE__*/_react.default.createElement(_ui.CustomDataEditor, (0, _extends2.default)({
    message: value,
    errors: [error],
    customData: _ui.EDITOR_PLACEHOLDERS,
    disabled: disabled,
    charsLimit: charsLimit,
    insertDataButtonProps: {
      'data-testid': "templateField.".concat(name, ".insertDataBtn")
    },
    textFieldProps: {
      error: !!error,
      rows: 8
    }
  }, formProps));
};

exports.TemplateMessageField = TemplateMessageField;
TemplateMessageField.propTypes = {
  disabled: _propTypes.default.bool,
  error: _propTypes.default.string,
  value: _propTypes.default.string.isRequired,
  charsLimit: _propTypes.default.number.isRequired,
  name: _propTypes.default.string.isRequired
};
TemplateMessageField.defaultProps = {
  disabled: false,
  error: ''
};